import React, { useEffect, useState } from 'react';
import { Route, Switch, withRouter } from "react-router-dom";

import MasterRouter from "../routersMaster";
import { useTranslation } from "react-i18next";
import MasterSideMenu from '../menu/MasterSideMenu';
import LogoutPage from './login/SGK/LogoutPage';

const MasterHomePage = (props) => {

    const { t } = useTranslation();
    const [pinned, setPinned] = useState(true);

    const onMenuToggle = (pin) => {
        setPinned(pin);

        const content = document.getElementById('content');
        const toolbar = document.getElementById('fixedToolBar');

        if (content && toolbar) {
            if (pin) {
                content.classList.add("expanded");
                toolbar.classList.add("expanded");
            } else {
                content.classList.remove("expanded");
                toolbar.classList.remove("expanded");
            }
        }
    };

    useEffect(() => {
        const content = document.getElementById('content');
        const toolbar = document.getElementById('fixedToolBar');

        if (content && toolbar) {
            onMenuToggle(pinned);
        }
    }, [pinned]);

    const renderRoutes = (items) => {
        return items.map((item, key) => {
            const hasNestedGroups = item.isGroup && item.items?.some(subItem => subItem.isGroup);

            if (hasNestedGroups) {
                return item.items.map((subItem, index) => renderRoutes([subItem]));
            }

            return item.isGroup ?
                item.items.map((page, subKey) => (
                    <Route exact path={page.path} key={subKey}>
                        <page.component title={t(page.title)} />
                    </Route>
                )) :
                <Route exact path={item.path} key={key}>
                    <item.component title={t(item.title)} />
                </Route>;
        });
    };

    const RenderPages = () => {
        return (
            <Switch>
                {renderRoutes(MasterRouter)}
            </Switch>
        );
    };

    return (
        <div className="App">
            <MasterSideMenu onToggle={onMenuToggle} pinned={pinned} />
            <div id="content" className="content expanded">
                <Switch>
                    <Route exact path="/">
                        {/* Add default content for the home page */}
                    </Route>
                    <Route exact path="/logout">
                        <LogoutPage />
                    </Route>
                    <RenderPages />
                </Switch>
            </div>
        </div>
    );
};

export default withRouter(MasterHomePage);
